import React from "react";
import Gutters from "../../config/gutters";

const Row = (props) => (
  <div
    className={props.className}
    style={{
      className: props.className,
      backgroundColor: props.bgc,
      backgroundImage: "url(" + props.bgi + ")",
      backgroundRepeat: props.backgroundRepeat,
      backgroundSize: props.bgSize,
      padding: props.padding,
      height: props.bgh + "px",
      display: props.display,
      maxWidth: props.maxWidth,
      width: props.width,
      margin: props.margin,
      position: "relative",
      textAlign: props.textAlign,
      ...props.styles,
    }}
  >
    {props.children}
  </div>
);

Row.defaultProps = {
  maxWidth: "1200px",
  width: "100%",
  display: "inline-table",
  padding: Gutters.spacings[2] + " 24px",
  bgc: "#fff",
  backgroundRepeat: " no-repeat",
  bgSize: "",
  bgi: "none",
  className: "row",
  styles: {
    color: "#444",
    fontSize: "16px",
    lineHeight: "24px",
    border: "0px dashed #cc00cc",
  },
  children: "Row builder without data",
  margin: "0",
};

export default Row;
